import styled from 'styled-components';
import {} from './index.js';
import React from 'react';
import { getMargins, getTypographyStyles, SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_200, SYS_SPACE_FIXED_25, SYS_SPACE_FIXED_50, SEM_TYPOGRAPHY_FEEDBACK_COPY, SEM_TYPOGRAPHY_FEEDBACK_HEADLINE } from '@oneaudi/unified-web-common';
import { Icon } from '../index.js';
import { TextLink } from '../text-link/index.js';
export const StyledContainer = styled.div `
  display: flex;
  flex-direction: row;
  background-color: ${(props) => props.theme.global.color.elevation.level4};
  color: ${(props) => props.theme.sem.color.feedback.foreground.text.default};
  box-shadow: ${(props) => props.theme.global.boxShadow.elevation.level4};
  margin: ${(props) => getMargins(props.margin)};

  .spacer {
    margin-top: ${SYS_SPACE_FIXED_200};
  }
`;
export const StyledLeftContainer = styled.div `
  padding: ${SYS_SPACE_FIXED_200};
  display: flex;
  width: 100%;
`;
export const StyledIconButtonContainer = styled.div `
  display: flex;
  padding-top: ${SYS_SPACE_FIXED_50};
  width: auto;
`;
export const StyledContentContainer = styled.div `
  display: flex;
  flex-direction: column;
`;
export const StyledTextLinkButton = styled(TextLink) `
  margin-top: ${SYS_SPACE_FIXED_200};
  align-self: start;
`;
export const StyledError = styled.span `
  color: ${(props) => props.theme.sem.color.feedback.foreground.text.informative};
  ${getTypographyStyles(SEM_TYPOGRAPHY_FEEDBACK_COPY)}
`;
export const StyledTextLink = styled(TextLink) `
  margin-top: ${SYS_SPACE_FIXED_200};
  align-self: start;
`;
export const StyledTitle = styled(({ ...props }) => {
    const HtmlTag = props.tag;
    return React.createElement(HtmlTag, { ...props }, props.text);
}) `
  margin: ${SYS_SPACE_FIXED_25} 0;
  ${getTypographyStyles(SEM_TYPOGRAPHY_FEEDBACK_HEADLINE)}
`;
export const StyledIcon = styled(Icon) `
  flex-shrink: 0;
  margin-right: ${SYS_SPACE_FIXED_150};

  color: ${(props) => props.name === 'info-circle'
    ? props.theme.cmp.color.feedback.infoBox.foreground.icon.warning
    : props.name === 'select-circle'
        ? props.theme.cmp.color.feedback.infoBox.foreground.icon.success
        : props.name === 'break'
            ? props.theme.cmp.color.feedback.infoBox.foreground.icon.default
            : props.theme.cmp.color.feedback.infoBox.foreground.icon.error};
`;
export const StyledUpperContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${SYS_SPACE_FIXED_100};
  width: 100%;
`;
export const StyledCopy = styled.span `
  ${getTypographyStyles(SEM_TYPOGRAPHY_FEEDBACK_COPY)}
  margin-top: ${SYS_SPACE_FIXED_25}
`;
//# sourceMappingURL=index.styles.js.map